import { render } from "./addRect.vue?vue&type=template&id=39a3df6b&scoped=true"
import script from "./addRect.vue?vue&type=script&lang=js"
export * from "./addRect.vue?vue&type=script&lang=js"

import "./addRect.vue?vue&type=style&index=0&id=39a3df6b&scoped=true&lang=css"

import exportComponent from "C:\\vue2025\\cmsmap2023\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a3df6b"]])

export default __exports__